document.addEventListener("DOMContentLoaded", function () {
    "use strict";

    //TOGGLE VISIBILITY LOGIC 
    const toggle = document.getElementById("zwssgr-custom_email_review_email_enabled");
    const widgetSelector = document.getElementById("zwssgr-custom-widget-selector");

    if (toggle && widgetSelector) {
        const updateVisibility = () => {
            if (toggle.checked) {
                toggle.value = 1;
                widgetSelector.classList.remove("hidden");
                widgetSelector.classList.add("visible");
            } else {
                toggle.value = 0;
                widgetSelector.classList.remove("visible");
                widgetSelector.classList.add("hidden");
            }
        };

        updateVisibility();
        toggle.addEventListener("change", updateVisibility);
    }

    // CUSTOM MULTI-SELECT LOGIC
    const select = document.getElementById("zwssgr_custom_select_field");
    const searchInput = document.getElementById("zwssgr-custom-search-input");
    const tagContainer = document.getElementById("zwssgr-selected-tags");
    const dropdown = document.getElementById("zwssgr-custom-dropdown");

    if (select && searchInput && tagContainer && dropdown) {
        const options = Array.from(select.options);

        function renderTags() {
            tagContainer.innerHTML = "";

            options.forEach(opt => {
                if (opt.selected) {
                    const tag = document.createElement("div");
                    tag.className = "zwssgr-custom-selected-tag";
                    tag.textContent = opt.text;

                    const remove = document.createElement("span");
                    remove.className = "zwssgr-remove-tag";
                    remove.textContent = "×";
                    remove.onclick = () => {
                        opt.selected = false;
                        renderTags();
                        renderDropdown(searchInput.value);
                    };

                    tag.appendChild(remove);
                    tagContainer.appendChild(tag);
                }
            });
        }

        function renderDropdown(filter = "") {
            dropdown.innerHTML = "";

            const filtered = options.filter(opt =>
                !opt.selected && opt.text.toLowerCase().includes(filter.toLowerCase())
            );

            if (filtered.length === 0) {
                dropdown.style.display = "none";
                return;
            }

            filtered.forEach(opt => {
                const li = document.createElement("li");
                li.textContent = opt.text;
                li.onclick = () => {
                    opt.selected = true;
                    renderTags();
                    searchInput.value = "";
                    renderDropdown();
                };
                dropdown.appendChild(li);
            });

            dropdown.style.display = "block";
        }

        searchInput.addEventListener("input", function () {
            renderDropdown(this.value);
        });

        searchInput.addEventListener("focus", function () {
            renderDropdown(this.value);
        });

        document.addEventListener("click", function (e) {
            if (!e.target.closest(".zwssgr-custom-multiselect-wrapper")) {
                dropdown.style.display = "none";
            }
        });

        // Form submission handler
        document.querySelector('.zwssgr-setting-form').addEventListener('submit', function(e) {
            // Ensure the hidden select element has all selected values
            const selectedTags = document.querySelectorAll('.zwssgr-custom-selected-tag');
            const selectElement = document.getElementById('zwssgr_custom_select_field');
            
            // Clear existing selections
            Array.from(selectElement.options).forEach(opt => {
                opt.selected = false;
            });
            
            // Set selected options based on visible tags
            selectedTags.forEach(tag => {
                const optionText = tag.textContent.replace('×', '').trim();
                const option = Array.from(selectElement.options).find(
                    opt => opt.text === optionText
                );
                if (option) {
                    option.selected = true;
                }
            });
        });

        // Initial render
        renderTags();
    }
});